"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CalendarSyncStatus = void 0;
var CalendarSyncStatus;
(function (CalendarSyncStatus) {
    CalendarSyncStatus["SYNCED"] = "SYNCED";
    CalendarSyncStatus["PENDING"] = "PENDING";
    CalendarSyncStatus["FAILED"] = "FAILED";
    CalendarSyncStatus["CONFLICT"] = "CONFLICT";
})(CalendarSyncStatus || (exports.CalendarSyncStatus = CalendarSyncStatus = {}));
